import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FaqItem as Block } from "./FaqItemBlock";
import { defaultData } from "./FaqItemDefaultData";
import imagePreview from "./faq_item_preview.png";

export const FaqItemBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "FAQ item",
    version: 1,
    isHidden: true,
    nameI18n: "builder_ui.block_type.faq_item",
    props: {
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
